







import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Snackbar extends Vue {
  snackbarVisible: boolean = false
  snackbarMessage: string = ''
  snackbarTimeout: number = 60 * 1000

  public showSnackbar (message: string, second: number = 60) {
    this.snackbarMessage = message
    this.snackbarTimeout = second * 1000
    this.snackbarVisible = true
  }
}
